export const GET_KURSUS_REQUEST = 'mtf/app/GET_KURSUS_REQUEST'
export const GET_KURSUS_SUCCESS = 'mtf/app/GET_KURSUS_SUCCESS'
export const GET_KURSUS_ERROR = 'mtf/app/GET_KURSUS_ERROR'

export const BUY_KURSUS_REQUEST = 'mtf/app/BUYKURSUS_REQUEST'
export const BUY_KURSUS_SUCCESS = 'mtf/app/BUY_KURSUS_SUCCESS'
export const BUY_KURSUS_ERROR = 'mtf/app/BUY_KURSUS_ERROR'

export const GET_KURSUS_BY_ID_REQUEST = 'mtf/app/GET_KURSUS_BY_ID_REQUEST'
export const GET_KURSUS_BY_ID_SUCCESS = 'mtf/app/GET_KURSUS_BY_ID_SUCCESS'
export const GET_KURSUS_BY_ID_ERROR = 'mtf/app/GET_KURSUS_BY_ID_ERROR'

export const GET_LESSON_BY_ID_REQUEST = 'mtf/app/GET_LESSON_BY_ID_REQUEST'
export const GET_LESSON_BY_ID_SUCCESS = 'mtf/app/GET_LESSON_BY_ID_SUCCESS'
export const GET_LESSON_BY_ID_ERROR = 'mtf/app/GET_LESSON_BY_ID_ERROR'

export const SET_LESSON_IS_COMPLETE_REQUEST = 'mtf/app/SET_LESSON_IS_COMPLETE_REQUEST'
export const SET_LESSON_IS_COMPLETE_SUCCESS = 'mtf/app/SET_LESSON_IS_COMPLETE_SUCCESS'
export const SET_LESSON_IS_COMPLETE_ERROR = 'mtf/app/SET_LESSON_IS_COMPLETE_ERROR'